module.exports = __webpack_public_path__ + "media/images/products/retailers-og-2-3fd1d916364d95097335987f810094b5.jpg";